import Turnstile, {useTurnstile} from 'react-turnstile';

export default function TurnstileWidget({
  onVerify,
  ...props
}: {
  onVerify: (token: string) => void;
  [key: string]: any;
}) {
  const turnstile = useTurnstile();

  return (
    <Turnstile
      {...props}
      sitekey="0x4AAAAAAAcZdZg-G_cmB9SW"
      onVerify={token => onVerify(token)}
    />
  );
}
